<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>

    <md-card>
      <md-card-content>
        <div v-if="showMain==true">
          <md-layout md-gutter>
            <md-layout md-flex="10">
              <!-- <md-button
              class="md-raised md-primary md-button-color heght-1px"
              style=" margin-top"
              @click="previousVendorView"
              >&laquo; Back</md-button>-->
            </md-layout>d
            <md-layout md-flex="30"></md-layout>
            <md-layout md-flex="40">
              <h2>Agent & CoLoader</h2>
            </md-layout>
          </md-layout>

          <hr class="hr-s" />

          <b-row>
            <b-col md="4">
              <label for="blType">Agent / CoLoader</label>
              <model-list-select
                :list="categoryTypeList"
                v-model="agentColaderModel.categoryType"
                option-value="categoryTypeVal"
                option-text="categoryTypeTxt"
                placeholder="Select Type"
                :isDisabled="agentColaderModel.agntColoaderId!=''?true:false"
              ></model-list-select>
              <span class="error" v-if="!agentColaderModel.categoryType">{{categoryTypeError}}</span>
            </b-col>
            <b-col md="4"  v-if="agentColaderModel.categoryType=='Agent'">
              <label>Agent Name</label>
              <b-form-input :formatter="capitalizeAll" id="agentName" name="agentName" v-model="agentColaderModel.agentName"></b-form-input>
            </b-col>
            <b-col md="4"  v-if="agentColaderModel.categoryType=='CoLoader'">
              <label>CoLoader Name</label>
              <b-form-input :formatter="capitalizeAll"
                id="coLoaderName"
                name="coLoaderName"
                v-model="agentColaderModel.coLoaderName"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <label>Contact No.</label>
              <b-form-input :formatter="capitalizeAll"
                id="contactNumber"
                name="contactNumber"
                v-model="agentColaderModel.contactNumber"
              ></b-form-input>
            </b-col>
            <b-col md="4">
              <label>Email-Id</label>
              <b-form-input :formatter="capitalizeAll" id="emailId" name="emailId" v-model="agentColaderModel.emailId"></b-form-input>
            </b-col>
            <b-col md="4">
              <label>Company Name</label>
              <b-form-input :formatter="capitalizeAll"
                id="companyName"
                name="companyName"
                v-model="agentColaderModel.companyName"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <label>Address</label>
              <b-form-textarea :formatter="capitalizeAll" id="address" name="address" v-model="agentColaderModel.address"></b-form-textarea>
            </b-col>
          </b-row>
          <hr class="hr-border" />

          <md-layout md-gutter class="mrgtop-button">
            <md-layout md-flex="40"></md-layout>
            <md-button
              class="md-raised md-primary md-button-color heght-1px mrgtop-2per"
              @click="addAgentColoader"
              id="addButtonLoader"
            >{{agentColaderModel.agntColoaderId!=''?'Edit':'Add'}}</md-button>
            <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
          </md-layout>
          <hr class="hr-s" />
        </div>
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">Agent & CoLoader Details</h3>
            <md-button
              v-if="showMain==false"
              @click="goToMain"
              class="md-raised md-primary md-button-color md-theme-default back heght-1px pull-right"
            >Add New</md-button>
            
            <b-button
              size="sm"
              class="ml-2 pull-right back heght-20px"
              :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
              @click="getData('Excel')"
              variant="outline-info"
              > {{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export as Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>

          </div>
          <hr class="hr-s" />
          <!-- /.box-header -->
          <div class="box-body">
            <table id="agentCo12" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr no</th>
                  <th>Category Type</th>
                  <th>Agent Name</th>
                  <th>CoLoader Name</th>
                  <th>Contact Number</th>
                  <th>Email Address</th>
                  <th>Company Name</th>
                  <!-- <th>Edit</th> -->
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item1,index) in allAgentColoaderData"
                  :key="index"
                  @click="viewEdit(item1)"
                  class="pointer"
                >
                  <td>{{index+1}}</td>
                  <td>{{item1.categoryType}}</td>
                  <td>{{(item1.agentName!='')?item1.agentName:'--'}}</td>
                  <td>{{(item1.coLoaderName!='')?item1.coLoaderName:'--'}}</td>
                  <td>{{item1.contactNumber}}</td>
                  <td>{{item1.emailId}}</td>
                  <td>{{item1.companyName}}</td>

                  <!-- <td>
                    <md-button class="md-icon-button md-raised md-dense" @click="viewEdit(item1)">
                      <md-icon>edit</md-icon>
                    </md-button>
                  </td>-->
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>
      </md-card-content>
    </md-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
      @close="onClose"
    ></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Main Master")) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/agentColoader/agentColoaderForm"
      );
      this.getData("Normal");
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export as Excel",
      alert: {
        content:
          this.$sessionsStorage.get("editRefuelId") != "" &&
          this.$sessionsStorage.get("editRefuelId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      showMain: false,
      allAgentColoaderData: ["sas"],
      agentColaderModel: {
        categoryType: "",
        agntColoaderId: "",
        agentName: "",
        coLoaderName: "",
        contactNumber: "",
        emailId: "",
        companyName: "",
        address: ""
      },
      categoryTypeList: [
        {
          categoryTypeVal: "Agent",
          categoryTypeTxt: "Agent"
        },
        {
          categoryTypeVal: "CoLoader",
          categoryTypeTxt: "CoLoader"
        },
        {
          categoryTypeVal: "CHA",
          categoryTypeTxt: "CHA"
        },
        {
          categoryTypeVal: "IATA",
          categoryTypeTxt: "IATA"
        }
      ],
      isLoading: true,
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editRefuelId") != "" &&
          this.$sessionsStorage.get("editRefuelId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editRefuelId") != "" &&
          this.$sessionsStorage.get("editRefuelId") != undefined
            ? "Update"
            : "New"
      },

      validate: true,
      categoryTypeError: ""
    };
  },

  mounted() {
    //this.JqueryFun();
  },
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading
    CustomLoader,
  },
  computed: {},
  methods: {
    goToMain() {
      this.showMain = true;
    },
    viewEdit(item1) {
      this.showMain = true;

      let arrayFilter = this.allAgentColoaderData.filter(x => {
        return x.agntColoaderId == item1.agntColoaderId;
      });

      Object.keys(this.agentColaderModel).map(x => {
        this.agentColaderModel[x] = arrayFilter[0][x] || "";
      });
    },
    JqueryFun() {
      return $(function() {
        return $("#agentCo12").DataTable();
      });
    },
    onClose(type) {
      //   this.$router.push({
      //     path: "/vendorMaster/viewVendorMaster"
      //   });
    },
    previousVendorView() {
      //   this.$router.push({
      //     path: "/vendorMaster/viewVendorMaster"
      //     // params:{
      //     //   "userId":res.data.Id,
      //     // }
      //   });
    },

    expandEvent(e) {
      e.preventDefault();
    },

    validateRefuelStation() {
      let validate_new = true;

      if (this.agentColaderModel.categoryType == "") {
        $("#categoryType").focus();
        this.categoryTypeError = "Select Category";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addAgentColoader() {
      this.validateRefuelStation();
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addAgentColoader.php`,
          data: JSON.stringify(this.agentColaderModel),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            if ((result.data.msg = "Inserted Successfully")) {
              Object.keys(this.agentColaderModel).map(x => {
                this.agentColaderModel[x] = "";
              });
            }

            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            this.$refs["addPop"].open();
            this.getData("Normal");
            this.showMain = false;
          })

          .catch(error => {});
      }
    },
    getData(type) {
      this.isLoading = true;
      let type_Size = {
        categoryType: "categoryType",
        Status:this.$route.path=='/agentColoader/agentColoaderForm'?'':'1',
        type: type
      };

      if(type == "Excel"){
        this.ExcelBtnName = "Downloading....";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/fetchtoAgentColoader.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.agentCoLoaderTable.length > 0) {
              this.allAgentColoaderData = data.agentCoLoaderTable;
            }

            if (type == "Excel") {
              if (data.agentCoLoaderTable.length > 0) {
                this.allAgentColoaderData = data.agentCoLoaderTable;
                this.totalRows = data.agentCoLoaderTable.length;
                this.ExcelBtnName = "Export as Excel";
              }
              window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.agentCoLoaderTable.length > 0) {
                this.allAgentColoaderData = data.agentCoLoaderTable;
                this.totalRows = data.agentCoLoaderTable.length;
                console.log("Commodity Master List response=>", data);
              }
            }
            //    console.log(this.allAgentColoaderData);

            this.isLoading = false;
            this.JqueryFun();
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 16% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// ledgerMaster.vue?d79911c6